import {
  countEmployeesWithCoverageCorrections,
  countEmployeesWithPrefunding,
  countEmployeesWithPremiums,
  countEmployeesWithQME,
  formatMonthDateRange,
  getNextMonthName,
  getPriorMonthEnrollmentCutoffDate,
  getPriorMonthName,
} from 'utils/billing'

import { CostBreakdownTable } from './CostBreakdownTable'
import { useInvoice } from './InvoiceContext'
import { InvoiceCostBreakdownMobile } from './mobile'
import { type CostBreakdownItem } from './types'

export function InvoiceCostBreakdown () {
  const { invoice, enrichedMemberInvoices } = useInvoice()

  const items: CostBreakdownItem[] = [
    {
      title: `Pre-payment for ${getNextMonthName(invoice.period_end_date)} insurance coverage`,
      description: `Billing in advance for coverage from ${formatMonthDateRange(invoice.period_end_date)}.`,
      employeeCount: countEmployeesWithPrefunding(enrichedMemberInvoices),
      amount: invoice.amounts?.insurance_premiums_total?.formatted_amount || '$0.00',
    },
    {
      title: `Payment for ${getPriorMonthName(invoice.period_start_date)} Insurance coverage`,
      description: `Insurance coverage for new employees who enrolled for ${formatMonthDateRange(invoice.period_start_date)} coverage after ${getPriorMonthEnrollmentCutoffDate(invoice.period_start_date)}.`,
      employeeCount: countEmployeesWithPremiums(enrichedMemberInvoices),
      amount: invoice.amounts?.premiums?.formatted_amount ||
        invoice.amounts?.insurance_premiums_total?.formatted_amount ||
        '$0.00',
      link: {
        text: 'Why was I billed for 2 months of coverage?',
        href: '#',
      },
    },
    {
      title: `Changes in ${getPriorMonthName(invoice.period_start_date)} Insurance Coverage`,
      description: 'Includes factors like new dependents, moving, or cancelling plans that cause costs to change.',
      employeeCount: countEmployeesWithCoverageCorrections(enrichedMemberInvoices),
      amount: invoice.amounts?.coverage_corrections?.formatted_amount || '$0.00',
    },
    {
      title: 'Qualified medical expenses',
      description: 'Money your team used from their leftover allowance to cover copays, prescriptions, etc.',
      employeeCount: countEmployeesWithQME(enrichedMemberInvoices),
      amount: invoice.amounts?.other?.formatted_amount || '$0.00',
    },
  ]

  return (
    <>
      <CostBreakdownTable items={items} />
      <InvoiceCostBreakdownMobile items={items} />
    </>
  )
}
